'use client';
import { CustomEventName, GTMConstants, GTMEventKey, sendGTM } from '@fe-cnyes/fe-common-gtm';
import { SCREEN_SIZE } from '@fe-common-utils/constants/screen';
import { styled } from '@linaria/react';
import Link from 'next/link';

type BreadCrumbProps = { categoryId: number; slug: string; name: string };

const Wrapper = styled.section`
  margin-bottom: 16px;
  display: flex;
  align-items: center;

  @media screen and (max-width: ${SCREEN_SIZE.DESKTOP}px) {
    margin-left: 16px;
  }
`;

const LabelIcon = styled.img`
  width: 18px;
  height: 18px;
  margin-right: 4px;
`;

const BreadWrapper = styled.div`
  display: flex;
  align-items: center;
  gap: 27px;
`;

const BreadCrumbTag = styled(Link)`
  font-size: 14px;
  color: #515c69;
  position: relative;
  cursor: pointer;

  &:not(:last-of-type):after {
    content: '';
    display: block;
    position: absolute;
    top: 50%;
    right: -17px;
    transform: translateY(-50%);
    width: 7px;
    height: 10px;
    background-image: url('/assets/icons/arrows/symbol-icon-arrow-right.svg');
    background-repeat: no-repeat;
  }

  &:last-of-type {
    letter-spacing: 0.41px;
    color: #848d97;
  }
`;

interface BreadCrumbsProps {
  breadcrumbs: BreadCrumbProps[];
}

const onTagClick = (breadcrumb: BreadCrumbProps) => {
  sendGTM({
    [GTMEventKey.EVENT_NAME]: CustomEventName.CLICK_TAB,
    [GTMEventKey.SECTION]: GTMConstants.SECTION_PLACEHOLDER,
    [GTMEventKey.CLICK_ITEM]: breadcrumb.name
  });
};

const BreadCrumb: React.FC<BreadCrumbsProps> = ({ breadcrumbs = [] }) => {
  return (
    <Wrapper id='bread-crumb'>
      <LabelIcon src='/assets/icons/breadCrumb/symbol-icon-home.svg' alt='home-icon' />
      <BreadWrapper>
        {breadcrumbs.map(breadcrumb => (
          <BreadCrumbTag
            key={breadcrumb.categoryId}
            prefetch={false}
            href={`/news/cat/${breadcrumb.slug?.toLocaleLowerCase()}`}
            onClick={() => onTagClick(breadcrumb)}
          >
            {breadcrumb.name}
          </BreadCrumbTag>
        ))}
      </BreadWrapper>
    </Wrapper>
  );
};

export default BreadCrumb;
